
export const drawerWidth = 250